export const listApplications = `
   query listApplications {
       listApplications {
           items {
              id
              name
              description
              url
              logoUrl
              created
              updated
           }
       }
   }
`;

export const getApplication = `
   query getApplication($id:ID!) {
       getApplication(id:$id) {
         id
         name
         description
         url
         logoUrl
         created
         updated
       } 
}`;
